'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isClientSide = exports.isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};

exports.default = {
  isClientSide: isClientSide
};
//# sourceMappingURL=clientSide.js.map